import styled, { css } from 'styled-components';
import { ButtonIcon } from '@anwb/button';
import Icon from '@anwb/icon';
import { pxToRem } from '@anwb/style-utilities';
import Typography from '@anwb/typography';
import { getNotificationVariantStyles } from './helpers';
export const notificationContainerStyles = ({ theme, $variant, }) => css `
	border: ${pxToRem(theme.borderWidth[2])} solid ${theme.colors.informative.borderNotification};
	border-radius: ${pxToRem(theme.borderRadius.m)};
	display: grid;
	grid-column-gap: ${pxToRem(theme.spacing['200'])};
	grid-row-gap: ${pxToRem(theme.spacing['100'])};
	grid-template-columns: min-content auto min-content;
	grid-template-rows: auto;
	grid-template-areas:
		'icon title close-button'
		'. content content';

	padding: ${pxToRem(theme.spacing['200'])};

	width: 100%;
	height: auto;

	margin-top: 0 !important;

	margin-bottom: ${pxToRem(theme.spacing[200])} !important;

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.sm)}) {
		margin-top: 1.5rem;
		margin-bottom: ${pxToRem(theme.spacing[300])} !important;
	}
	@media (min-width: ${pxToRem(theme.viewportBreakpoint.md)}) {
	}

	${getNotificationVariantStyles($variant)}
`;
export const NotificationContainer = styled.div `
	${notificationContainerStyles}
`;
/**
 * Notification Icon
 */
export const notificationIconStyles = ({ theme }) => css `
	align-items: center;
	display: flex;
	grid-area: icon;
	line-height: ${pxToRem(theme.lineHeights['600'])};
`;
export const NotificationIcon = styled(Icon).attrs(() => ({
    size: 'xl',
})) `
	${notificationIconStyles}
`;
/**
 * Notification Title
 */
export const notificationTitleStyles = () => css `
	grid-area: title;
	margin-bottom: 0;
`;
export const NotificationTitle = styled(Typography).attrs({
    variant: 'notification-title',
}) `
	${notificationTitleStyles}
`;
/**
 * Notification Close Button
 */
export const notificationCloseButtonStyles = () => css `
	padding: 0;
`;
export const NotificationCloseButton = styled(ButtonIcon).attrs(() => ({
    icon: 'cross',
    size: 'xs',
})) `
	${notificationCloseButtonStyles}
`;
/**
 * Notification Content
 */
export const notificationContentStyles = () => css `
	grid-area: content;
`;
export const NotificationContent = styled(Typography).attrs({
    tagName: 'span',
    variant: 'body-text',
}) `
	${notificationContentStyles}
`;
//# sourceMappingURL=notification.styled.js.map